import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);

  // FIXED BACKEND URL
  const BACKEND_URL = "https://topnationapp-1-api.onrender.com";
  const API = `${BACKEND_URL}/api`;

  useEffect(() => {

    const storedToken = localStorage.getItem("token");

    if (storedToken) {

      setToken(storedToken);

      axios.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;

      try {

        const payload = JSON.parse(atob(storedToken.split(".")[1]));

        setUser({
          id: payload.user_id,
          name: payload.name || payload.email?.split("@")[0],
          email: payload.email
        });

      } catch (err) {

        console.log("JWT decode error", err);

      }

    }

  }, []);

  const login = async (email, password) => {

    const res = await axios.post(`${API}/auth/login`, {
      email,
      password
    });

    const newToken = res.data.token;

    localStorage.setItem("token", newToken);

    setToken(newToken);

    axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

    const payload = JSON.parse(atob(newToken.split(".")[1]));

    setUser({
      id: payload.user_id,
      name: payload.name || payload.email?.split("@")[0],
      email: payload.email
    });

  };

  const register = async (email, password, name) => {

    const res = await axios.post(`${API}/auth/register`, {
      email,
      password,
      name
    });

    const newToken = res.data.token;

    localStorage.setItem("token", newToken);

    setToken(newToken);

    axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

    const payload = JSON.parse(atob(newToken.split(".")[1]));

    setUser({
      id: payload.user_id,
      name: payload.name || payload.email?.split("@")[0],
      email: payload.email
    });

  };

  const logout = () => {

    localStorage.removeItem("token");

    setUser(null);

    setToken(null);

    delete axios.defaults.headers.common["Authorization"];

  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        login,
        register,
        logout,
        loading
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
